import React from 'react';
import Error from '../../forms/Error/Error';
import ButtonContainer from '../../forms/ButtonContainer/ButtonContainer';

export default function Navigation({ setJourney, formik }) {
    return (
        <>
            {Object.keys(formik.errors).length > 0 && (
                <Error touched={true} error="Please check the form, some required fields are empty." />
            )}
            <ButtonContainer>
                <button className="meatex-button" onClick={() => { setJourney('adtype') }}>Back</button>
                <button
                    type="submit"
                    className="meatex-button meatex-button--orange"
                >Submit Advert</button>
            </ButtonContainer>
        </>

    );
}